import React from 'react';

function withHooksComponent<T extends {}>(Component: React.ComponentType<React.PropsWithChildren<T>>) {
    return function WrappedComponent(props: T) {
        return <Component {...props} />;
    };
}

export default withHooksComponent;
